import "@/index.css";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { store } from "@/redux/store";
import App from "@/App";
import { HelmetProvider } from "react-helmet-async";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient({
  defaultOptions:{
    queries:{
      refetchOnWindowFocus: false
    }
  }
});

const onRedirectCallback = (appState) => {
  window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
}

root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: process.env.REACT_APP_WEBSITE,
      scope: "openid profile email offline_access",
      audience: 'https://tale.tn'
    }}
    cacheLocation="localstorage"
    onRedirectCallback={onRedirectCallback}
  >
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <HelmetProvider><App /></HelmetProvider>
        </Provider>
      </QueryClientProvider>
  </Auth0Provider>
);
